import { render, staticRenderFns } from "./leavemandiolg.vue?vue&type=template&id=72dad1f0&scoped=true"
import script from "./leavemandiolg.vue?vue&type=script&lang=js"
export * from "./leavemandiolg.vue?vue&type=script&lang=js"
import style0 from "./leavemandiolg.vue?vue&type=style&index=0&id=72dad1f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dad1f0",
  null
  
)

export default component.exports